import { render, staticRenderFns } from "./message-template.vue?vue&type=template&id=70567582&scoped=true"
import script from "./message-template.vue?vue&type=script&lang=js"
export * from "./message-template.vue?vue&type=script&lang=js"
import style0 from "./message-template.vue?vue&type=style&index=0&id=70567582&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70567582",
  null
  
)

export default component.exports